module.exports = __webpack_public_path__ + "img/badgirl.c1539b64.png";